module.exports = __webpack_public_path__ + "a61c401844c1de5c3538e6e260b1a531.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-8.png
// module id = 2925
// module chunks = 0